import { InferType, object, string, number } from 'yup'

export interface IOutboundInputOptionsSchema {
  accountingInvoiceId?: number
  changedField?: string
  changedShipperStopSequence?: number
  shipmentId?: number
}

export const OutboundInputOptionsSchema = object<IOutboundInputOptionsSchema>({
  accountingInvoiceId: number(),
  changedField: string(),
  changedShipperStopSequence: number(),
  shipmentId: number(),
})

export type TOutboundInputOptionsSchema = InferType<typeof OutboundInputOptionsSchema>
